module.exports = __webpack_public_path__ + "DennchenLama-2a6e2966.webp";